module.exports = __webpack_public_path__ + "img/foravila-rentals-logo.ce7a28b8.png";